<template>
  <div id="video-wrapper">
    <div class="main-container">
      <div class="video-wrapper" :class="{ 'full-width': isFullWidth }">
        <div class="spinner-wrapper" v-if="!(isPlayerReady ) && !currentVideo.protected">
          <spinner-loader :show-text="false"></spinner-loader>
        </div>
        <div class="row">
          <div :class="{ 'col-md-12': isFullWidth&&isVideoHd , 'col-md-8': (isSideNav || isFullWidth&&!isVideoHd) && !canComment ,'col-md-9':canComment}">
            <div class="video-container">
              <custom-msg  :current="currentVideo" v-if="currentVideo.protected && !authenticateSSO && !authenticateCookie" ></custom-msg>
              <uep-player
                v-if="isPlayerReady && cdnReady "
                :url="currentVideo.cryptext"
                :query="query"
                @readyPlayer="readyPlayer"
                @infoDetails="infoDetails"
              ></uep-player>
            </div>
          </div>
          <div :class="{ 'col-md-12': isFullWidth&&isVideoHd, 'col-md-4': (isSideNav || isFullWidth&&!isVideoHd) && !canComment  , 'col-md-3':canComment}">
            <div class="info-wrapper" :class="{ 'info-wrapper-simple': !isRM }">
              <div class="info-container" v-if="isPlayerReady && currentVideo" :class="{ 'mt-4': isRM }">
                <h4 class="title">{{ currentVideo.title }}</h4>
                <div class="position-relative">
                  <VuePerfectScrollbar class="scroll-area" ref="ps" style="height: 120px">
                    <p class="description">
                      <span id="description" v-html="currentVideo.description"></span>
                    </p>
                  </VuePerfectScrollbar>
                  <div v-if="showMore" class="read-more">
                    <span v-if="descriptionVisible" class="read-more__less" @click="readLess">
                      {{ $t('buttons.see_less') }}</span
                    >
                    <span v-else="descriptionVisible" class="read-more__more" @click="readMore">
                      {{ $t('buttons.see_more') }}</span
                    >
                  </div>
                </div>

                <div class="metadata-container  desktop">
                  <div class="info" style="color: #282828!important">
                    <svg class="svg-mr" width="17px" height="17px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="ICONS/time" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path d="M-6.39488462e-14,9.49032258 C-6.39488462e-14,4.24896215 4.24772302,5.32907052e-14 9.4875549,5.32907052e-14 C14.7273868,5.32907052e-14 18.9751098,4.24896215 18.9751098,9.49032258 C18.9751098,14.731683 14.7273868,18.9806452 9.4875549,18.9806452 C4.24772302,18.9806452 -6.39488462e-14,14.731683 -6.39488462e-14,9.49032258 Z M9.89446559,16.4762545 L9.89446559,18.1454968 C14.3587735,17.9342447 17.9309489,14.3628536 18.1444217,9.89735197 L16.4714495,9.89735197 C16.2467189,9.89735197 16.0645388,9.71511871 16.0645388,9.49032258 C16.0645388,9.26552646 16.2467189,9.08329319 16.4714495,9.08329319 L18.140205,9.08329319 C17.9269071,4.61874763 14.356655,1.04745398 9.89341142,0.834093907 L9.89341142,2.5033362 C9.89341142,2.72813233 9.7112313,2.91036559 9.48650073,2.91036559 C9.26177016,2.91036559 9.07959004,2.72813233 9.07959004,2.5033362 L9.07959004,0.834093907 C4.61654378,1.04749602 1.04662,4.61891774 0.833850659,9.08329319 L2.50260615,9.08329319 C2.72733672,9.08329319 2.90951684,9.26552646 2.90951684,9.49032258 C2.90951684,9.71511871 2.72733672,9.89735197 2.50260615,9.89735197 L0.833850659,9.89735197 C1.04617766,14.3617444 4.61649956,17.9331078 9.07959004,18.1454968 L9.07959004,16.4762545 C9.07959004,16.2514584 9.26177016,16.0692251 9.48650073,16.0692251 C9.7112313,16.0692251 9.89341142,16.2514584 9.89341142,16.4762545 L9.89446559,16.4762545 Z M9.19449488,9.77503226 C9.11972784,9.6990288 9.07739552,9.5969479 9.07642753,9.49032258 L9.07642753,5.21440502 C9.07642753,4.98960889 9.25860765,4.80737563 9.48333821,4.80737563 C9.70806878,4.80737563 9.8902489,4.98960889 9.8902489,5.21440502 L9.8902489,9.32687814 L13.7769839,13.2790703 C13.93447,13.4398053 13.9318741,13.6978117 13.7711859,13.8553437 C13.6104978,14.0128757 13.3525666,14.0102791 13.1950805,13.8495441 L9.19449488,9.77503226 Z"  fill="#0D1E2F" fill-rule="nonzero"></path>
                      </g>
                    </svg>
                    {{ currentVideo.duration }}
                  </div>
                  <div class="info" style="color: #282828!important">
                    <svg class="svg-mr" width="28px" height="17px" viewBox="0 0 28 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path d="M3.78237189,11.9668926 L9.76996262e-14,8.0705879 L3.68960469,4.26918647 C6.30992353,1.54161245 9.92832576,7.28306304e-14 13.7100439,7.28306304e-14 C17.4917621,7.28306304e-14 21.1101643,1.54161245 23.7304832,4.26918647 L27.5128551,8.16549113 L23.8232504,11.9668926 C21.2030816,14.6947413 17.5846233,16.2365465 13.8028111,16.2365465 C10.0209989,16.2365465 6.40254062,14.6947413 3.78237189,11.9668926 Z M4.34740849,4.94616282 L1.31349927,8.07164239 L4.43912152,11.2909707 C6.88767233,13.8394354 10.2686901,15.2797891 13.802284,15.2797891 C17.3358779,15.2797891 20.7168958,13.8394354 23.1654466,11.2909707 L26.1983016,8.16549113 L23.0726794,4.94616282 C20.6243124,2.39775738 17.2434677,0.957425677 13.7100439,0.957425677 C10.1766201,0.957425677 6.79577547,2.39775738 4.34740849,4.94616282 Z M7.70073206,8.10960368 C7.79672133,4.79434987 10.5446488,2.17525643 13.8597056,2.23938792 C17.1747624,2.30351942 19.8193966,5.02693476 19.7871662,8.34342201 C19.7549358,11.6599093 17.0578729,14.3313825 13.7421962,14.3310374 C10.3571834,14.2755534 7.6554252,11.4904685 7.70178624,8.10433127 L7.70073206,8.10960368 Z M8.63051245,8.10960368 C8.71319335,10.9145704 11.0391338,13.1294703 13.8439562,13.0741572 C16.6487786,13.0188441 18.8856377,10.7139626 18.85773,7.90791563 C18.8298222,5.10186869 16.5475636,2.8419586 13.7421962,2.84247455 C10.8806988,2.88929465 8.59576596,5.24184028 8.63156662,8.10433127 L8.63051245,8.10960368 Z M10.0241288,7.63086963 C9.9994876,5.80772703 11.4547576,4.30863528 13.277306,4.27973127 C13.5416264,4.27973127 13.7559004,4.49406781 13.7559004,4.75846532 C13.7559004,5.02286284 13.5416264,5.23719937 13.277306,5.23719937 C11.9772607,5.26030549 10.9405066,6.33035919 10.9581259,7.63086963 C10.9581259,7.88769629 10.7499875,8.09589543 10.4932357,8.09589543 C10.236484,8.09589543 10.0283455,7.88769629 10.0283455,7.63086963 L10.0241288,7.63086963 Z"  fill="#0D1E2F" fill-rule="nonzero"></path>
                      </g>
                    </svg>                     {{ currentVideo.nbviews ? currentVideo.nbviews : 0  }}
                  </div>
                </div>
              </div>

              <div class="btns-wrapper desktop" v-if="isPlayerReady && currentVideo ">
                <button class="btn-embed" @click="clickModal">
                  <img
                    height="16"
                    src="data:image/svg+xml;base64,
    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"
                  />
                  {{ $t('buttons.integrate') }}
                </button>
                <div class="canLike" v-if="canLike">
                <b-button
                  size="sm"
                  :class="{liked:videoLiked ,like: !videoLiked}"
                  @click="updateLike(1)"
                >
                 <font-awesome-icon v-if="!videoLiked" :icon="['far', 'thumbs-up']" />
                  <font-awesome-icon  v-if="videoLiked" :icon="['fas', 'thumbs-up']" /> {{ nbLike }}
                </b-button>

                <b-button
                  size="sm"
                  :class="{liked:videoDisLiked ,like: !videoDisLiked}"
                  @click="updateLike(-1)"
                >
                  <font-awesome-icon v-if="!videoDisLiked" :icon="['far', 'thumbs-down']" />
                  <font-awesome-icon  v-if="videoDisLiked" :icon="['fas', 'thumbs-down']" /> {{ nbDisLike}}
                </b-button>
                </div>
                <div class="social-share-wrapper" v-if="componentStyle.header === 'large' || haveSocialMedia && !currentVideo.protected" >
                  <social-sharing
                    :url="videoMedia.link_embed"
                    :title="currentVideo.title"
                    hashtags="Empreinte"
                    inline-template
                  >
                    <div class="social-media-container">
                      <network network="facebook">
                        <div class="social-icon facebook">
                          <font-awesome-icon :icon="['fab', 'facebook-square']" />
                        </div>
                      </network>
                      <network network="twitter">
                        <div class="social-icon twitter">
                          <font-awesome-icon :icon="['fab', 'twitter-square']" />
                        </div>
                      </network>
                      <network network="linkedin">
                        <div class="social-icon linkedin">
                          <font-awesome-icon :icon="['fab', 'linkedin']" />
                        </div>
                      </network>
                    </div>
                  </social-sharing>
                </div>
              </div>

              <div class="btns-wrapper mobil" v-if="isPlayerReady && currentVideo">
                <div class="info">
                  <svg class="svg-mr" width="17px" height="18px" viewBox="0 0 20 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <path d="M0.294000006,18 C0.130662396,17.9967326 -3.55271368e-15,17.8633703 -3.55271368e-15,17.7 L-3.55271368e-15,1.5 C-3.55271368e-15,1.33662972 0.130662396,1.2032674 0.294000006,1.2 L2.35200001,1.2 L2.35200001,0.3 C2.35195563,0.13701019 2.48205457,0.00380308967 2.64500001,5.5067062e-14 L4.70000001,5.5067062e-14 C4.86333762,0.00326740248 4.99403268,0.136629716 4.99400001,0.3 L4.99400001,1.2 L11.462,1.2 L11.462,0.3 C11.4619673,0.136629716 11.5926624,0.00326740248 11.756,5.5067062e-14 L13.814,5.5067062e-14 C13.9773376,0.00326740248 14.1080327,0.136629716 14.108,0.3 L14.108,1.2 L16.166,1.2 C16.3289454,1.20380309 16.459,1.33701019 16.459,1.5 L16.459,17.7 C16.459,17.8629898 16.3289454,17.9961969 16.166,18 L0.294000006,18 Z M0.588000006,17.4 L15.877,17.4 L15.877,5.1 L0.588000006,5.1 L0.588000006,17.4 Z M0.588000006,4.5 L15.877,4.5 L15.877,1.8 L14.113,1.8 L14.113,2.7 C14.1130327,2.86337028 13.9823376,2.9967326 13.819,3 L11.761,3 C11.5976624,2.9967326 11.4669673,2.86337028 11.467,2.7 L11.467,1.8 L5.00000001,1.8 L5.00000001,2.7 C5.00003268,2.86337028 4.86933762,2.9967326 4.70600001,3 L2.64800001,3 C2.48505457,2.99619691 2.35495563,2.86298981 2.35500001,2.7 L2.35500001,1.8 L0.591000006,1.8 L0.588000006,4.5 Z M12.055,1.5 L12.055,2.4 L13.525,2.4 L13.525,0.6 L12.055,0.6 L12.055,1.5 Z M2.94000001,1.5 L2.94000001,2.4 L4.41100001,2.4 L4.41100001,0.6 L2.94000001,0.6 L2.94000001,1.5 Z M11.173,15.6 L2.64500001,15.6 L2.64500001,6.9 L13.819,6.9 L13.819,15.6 L11.173,15.6 Z M11.173,15 L13.231,15 L13.231,12.9 L11.173,12.9 L11.173,15 Z M8.52600001,15 L10.584,15 L10.584,12.9 L8.52600001,12.9 L8.52600001,15 Z M5.88000001,15 L7.93800001,15 L7.93800001,12.9 L5.88000001,12.9 L5.88000001,15 Z M3.23400001,15 L5.29200001,15 L5.29200001,12.9 L3.23400001,12.9 L3.23400001,15 Z M11.173,12.3 L13.231,12.3 L13.231,10.2 L11.173,10.2 L11.173,12.3 Z M8.52600001,12.3 L10.584,12.3 L10.584,10.2 L8.52600001,10.2 L8.52600001,12.3 Z M5.88000001,12.3 L7.93800001,12.3 L7.93800001,10.2 L5.88000001,10.2 L5.88000001,12.3 Z M3.23400001,12.3 L5.29200001,12.3 L5.29200001,10.2 L3.23400001,10.2 L3.23400001,12.3 Z M11.173,9.6 L13.231,9.6 L13.231,7.5 L11.173,7.5 L11.173,9.6 Z M8.52600001,9.6 L10.584,9.6 L10.584,7.5 L8.52600001,7.5 L8.52600001,9.6 Z M5.88000001,9.6 L7.93800001,9.6 L7.93800001,7.5 L5.88000001,7.5 L5.88000001,9.6 Z M3.23400001,9.6 L5.29200001,9.6 L5.29200001,7.5 L3.23400001,7.5 L3.23400001,9.6 Z"  fill="#0D1E2F" fill-rule="nonzero"></path>
                    </g>
                  </svg>
                  {{ currentVideo.date }}
                </div>
                <div class="info">
                  <svg class="svg-mr" width="17px" height="17px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="ICONS/time" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <path d="M-6.39488462e-14,9.49032258 C-6.39488462e-14,4.24896215 4.24772302,5.32907052e-14 9.4875549,5.32907052e-14 C14.7273868,5.32907052e-14 18.9751098,4.24896215 18.9751098,9.49032258 C18.9751098,14.731683 14.7273868,18.9806452 9.4875549,18.9806452 C4.24772302,18.9806452 -6.39488462e-14,14.731683 -6.39488462e-14,9.49032258 Z M9.89446559,16.4762545 L9.89446559,18.1454968 C14.3587735,17.9342447 17.9309489,14.3628536 18.1444217,9.89735197 L16.4714495,9.89735197 C16.2467189,9.89735197 16.0645388,9.71511871 16.0645388,9.49032258 C16.0645388,9.26552646 16.2467189,9.08329319 16.4714495,9.08329319 L18.140205,9.08329319 C17.9269071,4.61874763 14.356655,1.04745398 9.89341142,0.834093907 L9.89341142,2.5033362 C9.89341142,2.72813233 9.7112313,2.91036559 9.48650073,2.91036559 C9.26177016,2.91036559 9.07959004,2.72813233 9.07959004,2.5033362 L9.07959004,0.834093907 C4.61654378,1.04749602 1.04662,4.61891774 0.833850659,9.08329319 L2.50260615,9.08329319 C2.72733672,9.08329319 2.90951684,9.26552646 2.90951684,9.49032258 C2.90951684,9.71511871 2.72733672,9.89735197 2.50260615,9.89735197 L0.833850659,9.89735197 C1.04617766,14.3617444 4.61649956,17.9331078 9.07959004,18.1454968 L9.07959004,16.4762545 C9.07959004,16.2514584 9.26177016,16.0692251 9.48650073,16.0692251 C9.7112313,16.0692251 9.89341142,16.2514584 9.89341142,16.4762545 L9.89446559,16.4762545 Z M9.19449488,9.77503226 C9.11972784,9.6990288 9.07739552,9.5969479 9.07642753,9.49032258 L9.07642753,5.21440502 C9.07642753,4.98960889 9.25860765,4.80737563 9.48333821,4.80737563 C9.70806878,4.80737563 9.8902489,4.98960889 9.8902489,5.21440502 L9.8902489,9.32687814 L13.7769839,13.2790703 C13.93447,13.4398053 13.9318741,13.6978117 13.7711859,13.8553437 C13.6104978,14.0128757 13.3525666,14.0102791 13.1950805,13.8495441 L9.19449488,9.77503226 Z"  fill="#0D1E2F" fill-rule="nonzero"></path>
                    </g>
                  </svg>                  {{ currentVideo.duration }}
                </div>
                <div class="info">
                  <svg class="svg-mr" width="28px" height="17px" viewBox="0 0 28 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <path d="M3.78237189,11.9668926 L9.76996262e-14,8.0705879 L3.68960469,4.26918647 C6.30992353,1.54161245 9.92832576,7.28306304e-14 13.7100439,7.28306304e-14 C17.4917621,7.28306304e-14 21.1101643,1.54161245 23.7304832,4.26918647 L27.5128551,8.16549113 L23.8232504,11.9668926 C21.2030816,14.6947413 17.5846233,16.2365465 13.8028111,16.2365465 C10.0209989,16.2365465 6.40254062,14.6947413 3.78237189,11.9668926 Z M4.34740849,4.94616282 L1.31349927,8.07164239 L4.43912152,11.2909707 C6.88767233,13.8394354 10.2686901,15.2797891 13.802284,15.2797891 C17.3358779,15.2797891 20.7168958,13.8394354 23.1654466,11.2909707 L26.1983016,8.16549113 L23.0726794,4.94616282 C20.6243124,2.39775738 17.2434677,0.957425677 13.7100439,0.957425677 C10.1766201,0.957425677 6.79577547,2.39775738 4.34740849,4.94616282 Z M7.70073206,8.10960368 C7.79672133,4.79434987 10.5446488,2.17525643 13.8597056,2.23938792 C17.1747624,2.30351942 19.8193966,5.02693476 19.7871662,8.34342201 C19.7549358,11.6599093 17.0578729,14.3313825 13.7421962,14.3310374 C10.3571834,14.2755534 7.6554252,11.4904685 7.70178624,8.10433127 L7.70073206,8.10960368 Z M8.63051245,8.10960368 C8.71319335,10.9145704 11.0391338,13.1294703 13.8439562,13.0741572 C16.6487786,13.0188441 18.8856377,10.7139626 18.85773,7.90791563 C18.8298222,5.10186869 16.5475636,2.8419586 13.7421962,2.84247455 C10.8806988,2.88929465 8.59576596,5.24184028 8.63156662,8.10433127 L8.63051245,8.10960368 Z M10.0241288,7.63086963 C9.9994876,5.80772703 11.4547576,4.30863528 13.277306,4.27973127 C13.5416264,4.27973127 13.7559004,4.49406781 13.7559004,4.75846532 C13.7559004,5.02286284 13.5416264,5.23719937 13.277306,5.23719937 C11.9772607,5.26030549 10.9405066,6.33035919 10.9581259,7.63086963 C10.9581259,7.88769629 10.7499875,8.09589543 10.4932357,8.09589543 C10.236484,8.09589543 10.0283455,7.88769629 10.0283455,7.63086963 L10.0241288,7.63086963 Z"  fill="#0D1E2F" fill-rule="nonzero"></path>
                    </g>
                  </svg>                  {{ currentVideo.nbviews ? currentVideo.nbviews : 0  }}
                </div>
                <button class="btn-embed hide-btn-share" @click="clickModal">
                  <img
                    height="16"
                    src="data:image/svg+xml;base64,
    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"
                  />
                  {{ $t('buttons.integrate') }}
                </button>
                <div class="social-share-wrapper" v-if="componentStyle.header === 'large' || haveSocialMedia && !currentVideo.protected"  >
                  <social-sharing
                    :url="videoMedia.link_embed"
                    :title="currentVideo.title"
                    hashtags="Empreinte"
                    inline-template
                  >
                    <div class="social-media-container">
                      <network network="facebook">
                        <div class="social-icon facebook">
                          <font-awesome-icon :icon="['fab', 'facebook-square']" />
                        </div>
                      </network>
                      <network network="twitter">
                        <div class="social-icon twitter">
                          <font-awesome-icon :icon="['fab', 'twitter-square']" />
                        </div>
                      </network>
                      <network network="linkedin">
                        <div class="social-icon linkedin">
                          <font-awesome-icon :icon="['fab', 'linkedin']" />
                        </div>
                      </network>
                    </div>
                  </social-sharing>
                </div>
              </div>


            </div>

            <modal-export
              ref="exportModal"
              :embedUrl="videoMedia.link_embed"
              :embedUrlPer="videoMedia.link"
              :interactions="interactions"
              :textes="texts"
            >
            </modal-export>
            <div id="share-links" v-html="shareBtns"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ComponentVideo from '~/node_modules/component-video/src/components/Componentplay.vue';
import ModalExport from '~/node_modules/modal-export/src/components/Component.vue';
import SpinnerLoader from '../common/SpinnerLoader';
import Mixin from '@/mixins/Mixin';
import CustomMsg from './CustomMsg'

export default {
  name: 'CustomMainContent',
  components: {
    ComponentVideo,
    ModalExport,
    VuePerfectScrollbar,
    SpinnerLoader,
    CustomMsg
  },
  props: {
    // info:'',
    shareBtns: '',
  },
  data() {
    return {
      player: {},
      shareHtml: '',
      info: '',
      interactions: [],
      loading: false,
      check: false,
      fail: false,
      visible: false,
      required: false,
      embedUrlLecture: true,
      OptionInteraction: true,
      showMore: false,
      descriptionVisible: false,
      descriptionTruncate: 200,
      //playerSkin: 'dark',
      cdnReady: true,
      tokenUser:'',
      canLike:process.env.LIKE,
      authenticateCookie:''

    };
  },
  computed: {
    ...mapGetters({
      currentVideo: 'videos/getCurrentVideo',
      videoMedia: 'videos/getVideoMedia',
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      componentStyle: 'layout/getComponentStyle',
      haveSocialMedia:'layout/getHaveSocialMedia',
      videos: 'videos/getAllVideos',
      playerSkin: 'layout/getCurrentSkinPlayer',
      videoLiked: 'videos/getVideoLike',
      videoDisLiked: 'videos/getVideoDisLike',
      isVideoHd: 'layout/getIsVideoHd',
      nbLike:'videos/getNbLike',
      nbDisLike:'videos/getNbDisLike',
      authenticateSSO:'custom/isAuthenticateSaml',
    }),
    canComment(){
      return process.env.COMMENTS;
    },
    texts() {
      return {
        integrations: this.$t('labels.integrations'),
        integrations_options: this.$t('labels.integrations_options'),
        start_video_auto: this.$t('labels.start_video_auto'),
        default_color: this.$t('labels.default_color'),
        start_at: this.$t('labels.start_at'),
        share_social: this.$t('labels.share_social'),
        copy: this.$t('buttons.copy'),
        downloads: this.$t('labels.downloads'),
        embedTitle: this.$t('labels.embedTitle'),
        permalink: this.$t('labels.permalink'),
      };
    },
    isPlayerReady() {
      return this.currentVideo.cryptext && this.player;
    },
    isRM() {
      return this.isPlayerReady && this.currentVideo.type === 'isRM';
    },
    truncatedDescription() {
      if (!(this.info && this.info.description)) {
        return '';
      }
      return this.descriptionVisible
        ? this.info.description
        : `${this.info.description.substring(0, this.descriptionTruncate)}...`;
    },
    query() {
      let plugin = this.currentVideo.type === 'isInteractivity' ? 'interactivity' : 'navigation';
      return { skin: this.playerSkin, plugin: plugin, a: false,  videoStats: false, ...this.$route.query };
    },
  },
  watch: {
    currentVideo(value) {

      if(value){
        let videoCookie= 'VideoProtectedAuthentication-'+this.currentVideo.id;
        this.authenticateCookie = this.getCookieStats(videoCookie);
      }

      this.cdnReady = false;
      setTimeout(() => {
        this.cdnReady = true;
      }, 100);
    },
  },
  methods: {
    ...mapActions('videos', ['setCurrentVideo', 'getVideoMediaById','updateVotes']),

    readyPlayer(param) {
      this.player = param;
      this.updateVideoHeight();
      setTimeout(() => {
        this.updateReadMore();
      }, 1000);
    },
    infoDetails(param) {
      this.$Progress.finish();
     this.info = param;


     /*let tempElement = document.createElement("div");
      tempElement.innerHTML = this.info.description;
        var description = document.getElementById('description')

      setTimeout(()=>{
        if(description)
             description.appendChild(tempElement);
      },100)*/


      this.updateVideoHeight();
      this.updateReadMore();
    },
    clickModal() {
      this.$refs.exportModal.show();
    },
    updateVideoHeight() {
      const videoWrapper = document.querySelector('.video-wrapper.full-width');
      const videoContainer = document.querySelector('.video-container');
      const uepPlayer = document.querySelector('.uep_player_v2');
      const namePlayer = document.querySelector('#name_player');
      //const infoWrapper = document.querySelector('.info-wrapper-simple');
      const flashPlayer = document.querySelector('object.vjs-tech');
      const videoJS = document.querySelector('.video-js');
      const html5Video = document.querySelector('.video-js video.vjs-tech');
      try {
        if (videoWrapper) {
          if(this.isFullWidth && this.isVideoHd)
            videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 16)}px`;
          else
            videoWrapper.style.minHeight = `${videoWrapper.offsetWidth * (9 / 24)}px`;
        }
        const height = `${videoContainer.offsetWidth * (9 / 16)}px`;
        uepPlayer.style.height = height;
        namePlayer.style.height = height;
        videoJS.style.minHeight = '100%';
        if (
          (flashPlayer ||
            navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1) &&
          !html5Video
        ) {
          flashPlayer.setAttribute('style', `height:${height} !important`);
        }
      } catch (e) {
        // HACK for IE 11
        setTimeout(() => {
          this.updateVideoHeight();
        }, 3000);
      }
      setTimeout(() => {
        this.updateReadMore();
      }, 100);
    },
    updateReadMore() {
      const infoWrapper = document.querySelector('.info-wrapper');
      const videoJS = document.querySelector('.video-container');
      const titleEl = document.querySelector('.info-container .title');
      const descriptionEl = document.querySelector('.info-container .description');
      const metadataEl = document.querySelector('.metadata-container');
      const btnEmbedEl = document.querySelector('.btns-wrapper');

      const videoHeight = videoJS.offsetHeight;
      let descriptionHeight = videoHeight;

      if (titleEl) {
        let { height, marginTop, marginBottom } = window.getComputedStyle(titleEl);
        descriptionHeight -= parseFloat(height) + parseFloat(marginTop) + parseFloat(marginBottom);
      }

      if (metadataEl) {
        descriptionHeight -= metadataEl.offsetHeight;
      }

      if (btnEmbedEl) {
        let { height, marginTop, marginBottom } = window.getComputedStyle(btnEmbedEl);
        descriptionHeight -= parseFloat(height) + parseFloat(marginTop) + parseFloat(marginBottom);
      }

      if (descriptionEl) {
        this.showMore = descriptionEl.offsetHeight > 120;
      }

      if (this.$refs.ps) {
        if (this.showMore) {
          if (this.descriptionVisible) {
            if (this.isSideNav) {
              this.$refs.ps.$el.style.height = `${descriptionHeight}px`;
            } else {
              this.$refs.ps.$el.style.height = '300px';
            }
          } else {
            this.$refs.ps.$el.style.height = '120px';
          }
        } else {
          this.$refs.ps.$el.style.height = 'auto';
        }
      }
      if (this.isSideNav) {
        infoWrapper.style.height = `${videoHeight}px`;
      } else {
        infoWrapper.style.height = 'auto';
      }
    },
    readMore() {
      this.descriptionVisible = true;
      this.updateReadMore();
      setTimeout(() => {
        this.$refs.ps.update();
      }, 100);
    },
    readLess() {
      this.descriptionVisible = false;
      this.updateReadMore();
      setTimeout(() => {
        this.$refs.ps.update();
      }, 100);
    },
    updateLike(){
      let self=this;
      this.liked = !this.liked;
      var typeVote = this.liked ? 1 :0
      var params = {video:this.currentVideo.id,
      user:this.tokenUser,
      vote:typeVote};
      self.updateVotes(params);
    },
    getCookieStats: function (c_name) {
      var c_start;
      var c_end;
      if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) {
            c_end = document.cookie.length;
          }
          return unescape(document.cookie.substring(c_start, c_end));
        }
      }
      return "";
    },
  },
  created() {},
  mixins: [Mixin],
  mounted() {
    this.$nextTick(() => {
      this.updateVideoHeight();
      this.updateReadMore();
      if (!this.currentVideo || Object.keys(this.currentVideo).length === 0) {
        this.setCurrentVideo(this.videos[0]);
        this.getVideoMediaById(this.videos[0].id);
      }
      if(this.$cookies.isKey('tokenUserFo')){
        this.tokenUser=this.$cookies.get('tokenUserFo')

      }else{
        this.tokenUser= this.makeToken();
        this.$cookies.set('tokenUserFo', this.tokenUser);
      }
    });
    window.addEventListener('resize', () => {
      this.updateVideoHeight();
      this.updateReadMore();
    });
    window.addEventListener(
      'message',
      e => {
        try {
          if (JSON.parse(e.data).skin) {
            // this.playerSkin = JSON.parse(e.data).skin;
            let video = this.currentVideo;
            let cryptext = video.cryptext;
            video.skin = this.playerSkin;
            video.cryptext = '';
            this.setCurrentVideo(video);
            video.cryptext = cryptext;
            this.setCurrentVideo(video);
          }
        } catch (e) {
          // console.error(e);
        }
      },
      false,
    );
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables';
@import "../../assets/scss/mix";


.canLike , .btn-embed{
  @media screen and (max-width: 1200px) {
    margin-top: 0em!important;
  }
}

#video-wrapper .main-container .video-wrapper .info-wrapper .btns-wrapper{
  @media screen and (max-width: 770px) {
    flex-direction: row !important;
    margin-top: 0em !important;
  }
}


#video-wrapper {
  .modal-open {
    overflow: hidden;
  }

  /deep/ {
    .modal-data {
      overflow: hidden !important;
      --modal-export-modal-data-text-align: left;
    }

    .link-data {
      --modal-export-p-text-align: left;
      --modal-export-link-data-align-items: start;
      --modal-export-link-button-margin: 0;
    }
    @media screen and (max-width: 576px) {
      .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
        flex-direction: column !important;
      }
    }
  }

  /deep/ {
    .start-at-container {
      padding-bottom: 10px;
    }

    .link-detail,
    .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
      align-items: start;

      p:not(.link-p) {
        min-width: 110px;
      }

      .link-p,
      .textarea-code,
      .textarea-code-iframe {
        border: 1px solid #e0e0e0 !important;
        margin: 0 10px 10px !important;
        border-radius: 2px;
        padding: 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        flex-grow: 2 !important;
        @media screen and (max-width: 576px) {
          width: var(--modal-export-link-p-width, 100%) !important;
          margin: 5px 0 !important;
        }
      }

      .linkButton {
        margin: 0 !important;
        transition: 0.3s ease-in-out !important;
        min-width: 90px;

        &.is-copied {
          background: #4db6ac !important;
          color: #fff !important;
        }
      }
    }

    .link-container:last-child .link-detail {
      border-bottom: none !important;
    }
  }

  /deep/ .items.links .items.links {
    padding: 0 15px;
  }

  .main-container {
    position: relative;
    .video-wrapper {
      margin: 2em 15px 0;
      min-height: 30vh;
      &.full-width {
        padding: 1em;
        background-color: #eceff1;
        border-radius: 0.1em;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        .read-more {
          /*background-image: linear-gradient(*/
            /*to top,*/
            /*#ebeef1,*/
            /*rgba(235, 238, 241, 0.9) 50%,*/
            /*transparent*/
          /*) !important;*/
        }
      }
      &.collapsed {
        min-height: 0;
        padding: 0 1em !important;
        margin: 0 15px !important;
        overflow: hidden;
      }

      .info-wrapper {
        display: flex;
        align-items: start;
        justify-content: space-between;
        flex-direction: column;

        .info-container {
          flex-grow: 1;
          display: flex;
          flex-direction: column;

          .title {

            @include hasColorTitre(var(--color-title));
            margin-top: 0.2em;
            margin-bottom: 0.8em;
          }

          .description {
            color: #6a7887!important;
            font-size: 0.9em;
            word-break: break-word;
            padding-bottom: 20px;
            span {
              white-space: pre-line;
            }
          }
          .read-more {
            width: 100%;
            /*background-image: linear-gradient(*/
              /*to top,*/
              /*rgb(250, 250, 250),*/
              /*rgba(250, 250, 250, 0.9) 50%,*/
              /*transparent*/
            /*);*/
            z-index: 1;
            font-size: 0.8em;
            color: #8c8c8c;
            text-decoration: underline;
            margin-top: 0;
            bottom: 0;
            padding: 20px 0 0px;
            /* position: absolute; */
            span {
              cursor: pointer;
            }
          }

          .metadata-container {

            @include hasColorTitre(var(--color-title));

            font-size: 0.8em;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid #c5c6c7;
            padding-top: 0.8em;
            flex-shrink: 0;

            .info {
              display: flex;
              align-items: center;
              .icon {
                font-size: 1.2em;
                margin-right: 0.2em;
              }
            }
          }
        }
        .btns-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 0.8em;
          width: 100%;
          @media (max-width: 1199px) {
            flex-direction: column;
            align-items: start;
          }
          .btn-embed {
            border-radius: 2px;
            border: 1px solid #a0a0a0;
            background: #eceff1;
            padding: 3px;
            cursor: pointer;
            width: 160px;
            color: rgba(0, 0, 0, 0.8);
            flex-shrink: 0;
          }
          .liked{
            color: #fff;
            background-color: var(--primary-color);
            border-color: var(--primary-color);
            &:active,&:focus {
              color: #fff;
              background-color: var(--primary-color);
              border-color: var(--primary-color);
              box-shadow:none ;
            }
            &:hover {
              color: var(--primary-color);
              background-color:#fff ;
              border-color: var(--primary-color) ;
              box-shadow:none ;
            }

          }
          .like {
            color: var(--primary-color);
            background-color:#fff ;
            border-color: var(--primary-color) ;
            box-shadow:none ;

            &:active,&:focus {
              color: var(--primary-color);
              background-color:#fff ;
              border-color: var(--primary-color) ;
              box-shadow:none ;
            }
            &:hover {
              color: #fff;
              background-color: var(--primary-color);
              border-color: var(--primary-color);
              box-shadow:none ;
            }
          }
          .social-share-wrapper {
            .social-media-container {
              display: flex;
              align-items: center;
              /deep/ .social-icon {
                font-size: 1.8em;
                margin: 0 0.1em;
                cursor: pointer;
                &.facebook {
                  color: #3b5998;
                }
                &.twitter {
                  color: #55acee;
                }
                &.linkedin {
                  color: #0077b5;
                }
              }
            }
          }
        }
      }

      .video-container {
        width: 100%;
        min-height: 200px;

        /deep/ .component {
          height: initial;
          position: relative;
          width: initial;

          .uep_player {
            height: initial;

            &.isNotRadyPlayer:not(.vjs-tech-flash) {
              display: block;
            }

            .video-player {
              height: initial;

              .video-js:not(.vjs-rich-media-with-slide) {
                height: initial;

                video.vjs-tech {
                  position: relative;
                }

                &.vjs-fullscreen object.vjs-tech {
                  min-height: 100%;
                }
              }

              .video-js {
                .vjs-text-track-display > div > div {
                  width: 90% !important;
                  left: 5% !important;
                  font-size: 17.1px !important;
                }

                &.vjs-rich-media #sliders-container #vjs-sliders-content .vjs-sliders-field {
                  width: calc(((13% - 2em) - 4px) * 1.33) !important;
                }
              }
            }
          }
        }
      }
    }
  }

  /deep/ .modal-data {
    .column-2 {
      height: 32vw;
    }
  }

  /deep/ .start-at-container {
    display: none;
  }

  .spinner-wrapper {
    height: calc(100% - 2em);
    position: absolute;
    width: calc(100% - 4em);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 991px) {
    .main-container .video-wrapper {
      padding: 0.5em;
      margin: 1em 0 0;

      .info-wrapper {
        height: auto !important;

        .info-container {
          margin-top: 2em;
        }
      }
    }
  }

  @media (max-width: 980px) {
    /deep/ .modal-data {
      .column-2 {
        height: auto;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .video-container {
      /deep/ .component {
        .uep_player {
          .video-player {
            .video-js {
              &.skin-dark.vjs-rich-media.vjs-rich-media-with-slide {
                &.vjs-user-inactive {
                  #dark-overlay-buttons,
                  .overlay-btns {
                    display: none;
                  }
                }
                .vjs-tech,
                .vjs-slide-items {
                  height: 100% !important;
                }
                .vjs-big-play-button {
                  top: 50%;
                }
                .vjs-sliders-container {
                  display: none;
                }
                #dark-overlay-buttons {
                  align-items: start;
                  bottom: 3.2em !important;
                }
                .overlay-btns {
                  bottom: 2.2em !important;
                }
                .vjs-control-bar {
                  top: calc(80% - 0.2em);
                }
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    .col-lg-4 {
      padding-left: 5px;
    }
  }

  /*
   * IE 11 Support
   */

  .info-container {
    width: 100%;
  }

  // Modal
  .video-wrapper /deep/ .modal-overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
    outline: 9999px solid rgba(0, 0, 0, 0.5);

    .modal-data {
      background-color: #fff;
      height: 32vw;
      width: 90vw;
      border-radius: 2px;
      text-align: left;
      position: absolute;
      left: 31%;
      top: 50%;
      margin-left: -26vw;
      margin-top: -33vh;
      overflow: hidden;
      z-index: 99999;
      margin-bottom: 40px;

      .row-1 {
        float: left;
        width: 100%;

        .column-1 {
          float: left;
          width: 63%;
        }

        .column-2 {
          float: left;
          width: 37%;
          padding: 0;
          overflow: auto;

          .items {
            display: inline-block;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-pack: space-around;
            -ms-flex-pack: space-around;
            justify-content: space-around;
            overflow: hidden;
          }

          .links {
            width: 100%;
          }

          .tab-data {
            overflow: hidden;
            border-bottom: 1px solid #ccc;
            margin-bottom: 20px;

            button {
              background-color: #ffffff;
              float: left;
              border: none;
              outline: none;
              cursor: pointer;
              padding: 14px 16px;
              -webkit-transition: 0.3s;
              transition: 0.3s;

              .active {
                background-color: #ffffff;
              }
            }
          }

          .interactions {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 25px;
          }

          .link-data {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: start;
            border-bottom: none;
            margin-bottom: 10px;
          }

          p {
            font-size: 15px;
            font-weight: 300;
            position: relative;
            text-align: left;
            float: none;
            margin: 0;
            padding: 10px 5px;
            line-height: normal;
            color: #404040;
            flex-grow: 1;
          }

          .link-p {
            width: 19vw;
            word-break: break-all;
          }

          .linkButton {
            background-color: #f0f0f0;
            border: none;
            color: #8d8d8d;
            padding: 10px 25px;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 13px;
            margin: 4px 2px;
            transition-duration: 0.4s;
            cursor: pointer;
            border-radius: 5px;
          }

          .share-icon {
            width: 20px;
            color: #888;
            margin: 1px;
          }

          .icon-interactions {
            margin: 10px;
            padding: 10px 5px;
            width: 15px;
            height: 15px;
            color: #909090;
            cursor: pointer;
          }
        }
      }

      .row-2 {
        padding: 7px;
        width: 32px;
        height: 32px;
        background-color: white;
        border-radius: 16px;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
        font-size: 5px;
        margin: 10px 20px;

        .fa-times {
          cursor: pointer;
          width: 16px;
          height: 16px;
          padding: 0px;
        }
      }
    }
  }

  @media screen and (min-width: 980px) {
    /deep/ .modal-overlay .modal-data {
      height: 32vw !important;
      margin-top: -33vh !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
    }
  }

  @media screen and (max-width: 1703px) and (min-width: 980px) {
    /deep/ .modal-overlay .modal-data {
      height: 32vw !important;
      margin-top: -33vh !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
    }
  }

  @media screen and (max-width: 980px) {
    /deep/ .modal-overlay .modal-data {
      height: auto !important;
      margin-top: -44vh !important;
      overflow-y: auto !important;

      .row-1 {
        .column-2 {
          height: auto !important;
          width: 100% !important;
        }

        .column-1 {
          width: 100% !important;
        }
      }
    }
  }

  @media screen and (max-width: 1200px) and (min-width: 981px) {
    /deep/ .modal-overlay .linkButton {
      width: 100% !important;
    }
    /deep/ .modal-overlay .link-detail,
    /deep/
      .modal-overlay
      .link-data:not(.auto-play-container):not(.color-container):not(.start-at-container) {
      flex-direction: column !important;
      align-items: start !important;
      padding-bottom: 10px !important;

      .link-p,
      .textarea-code-iframe {
        width: 100% !important;
        flex-grow: 1 !important;
        margin: 0 0 8px 0 !important;
      }
    }
  }

  /deep/ input[type='color'] {
    max-width: 100px !important;
  }

  /deep/ .video-js > button.vjs-big-play-button {
    transition: none !important;
    width: 100px !important;
    height: 100px !important;
    margin-left: -50px;
    margin-top: -50px;
  }

  @media all and (-ms-high-contrast: none) {
    /deep/ {
      .video-js > button.vjs-big-play-button {
        transition: none !important;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .hide-btn-share{
    display: none!important;
  }

}
@media screen and (max-width: 767px){
  .desktop{
    display: none!important;
  }
  .social-media-container{
    position: relative!important;
    top: -0.5em!important;
  }

}
@media screen and (min-width: 766px){
  .mobil{
    display: none!important;
  }

}

/deep/  .component .uep_player *:not(.vjs-loading-spinner) {
  border-radius: 5px!important;
}

.video-wrapper{
  border-radius: 5px!important;
}

.svg-mr{
  margin-right: 10px;
}

.darkMode{
  #video-wrapper .main-container .video-wrapper .info-wrapper .info-container {
    .read-more {
      color: #cacaca!important;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Custom/CustomMainContent.vue